import { render, staticRenderFns } from "./InvoiceReportPrint.vue?vue&type=template&id=54b23fff&"
import script from "./InvoiceReportPrint.vue?vue&type=script&lang=js&"
export * from "./InvoiceReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports